// src/routes/authRoutes.jsx
// Authentication routes. Currently only login - extend here for
// password reset, register, etc. in future.
import Login from "../pages/auth/Login";

const authRoutes = {
  path: "login",
  element: <Login />,
};

export default authRoutes;